import React from "react"
import { fieldPropTypes } from "redux-form"
import FieldTextarea from "./FieldTextarea"

const FieldPercent = (props) => {
  const { input } = props
  const { value } = input
  if (value.toString().indexOf("%") !== -1) {
    input.value = parseFloat(input.value)
  } else {
    input.value *= 100
  }
  return <FieldTextarea {...props} />
}

FieldPercent.propTypes = {
  ...fieldPropTypes
}
export default FieldPercent
